<script setup lang="ts">
const { registerData } = storeToRefs(useRegisterStore());
const isDocumentCPFNameDisabled = ref(true);
</script>

<template>
  <form class="registerFields">
    <label
      class="registerLabel"
      for="name"
    >
      {{ $t('account.name') }} <span>*</span>
    </label>
    <BaseFormInput
      id="name"
      v-model="registerData.name"
      autocomplete="off"
      :disabled="isDocumentCPFNameDisabled"
      :initial-value="registerData.name"
      :name="'nome'"
      :required="true"
      type="nome"
      :with-check="true"
    />
    <AuthRegisterAddressFields />
  </form>
</template>

<style module lang="scss">
.editableField {
  @apply bg-auth-bg-inputs h-[46px] sm:h-[50px] rounded-md flex items-center relative;
}
</style>
